import { TABLE_COLUMN_WIDTH } from "components/ModelCompare/constants";

import type { Section } from "../types";
import { enterprise8PoE } from "./products/enterprise8PoE";
import { flex } from "./products/flex";
import { flex10GbE } from "./products/flex10GbE";
import { flex2_5G } from "./products/flex2_5G";
import { flex2_5GPoE } from "./products/flex2_5GPoE";
import { flexMini } from "./products/flexMini";
import { flexMini2_5G } from "./products/flexMini2_5G";
import { lite16PoE } from "./products/lite16PoE";
import { lite8PoE } from "./products/lite8PoE";
import { professional8PoE } from "./products/professional8PoE";
import { proXg8PoE } from "./products/proXg8PoE";
import { switchUltra } from "./products/switchUltra";
import {
  dimensions,
  downlinkSpeed,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  ports,
  powerMethod,
  uplinkSpeed,
} from "./properties";

export const SwitchingCompact: Section = {
  properties: [
    dimensions,
    ports,
    downlinkSpeed,
    uplinkSpeed,
    poeOutput,
    poeAvailability,
    powerMethod,
    mounting,
    outdoorReady,
  ],
  products: [
    proXg8PoE,
    flex2_5GPoE,
    flex2_5G,
    enterprise8PoE,
    professional8PoE,
    lite16PoE,
    lite8PoE,
    switchUltra,
    flex10GbE,
    flex,
    flexMini2_5G,
    flexMini,
  ],
  columnWidth: TABLE_COLUMN_WIDTH,
  showBadges: true,
};
